import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { formatNumber } from '~/utils/common';

import type { TypeOrderDetailOrderInfoData } from '~/types/order.types';

/**
 * [출고주문관리 > 출고 주문 상세] '상품 정보' 테이블
 */
const getOrderDetailProductInfoColumnDefs = () => {
  const columnDefs: ColDef<TypeOrderDetailOrderInfoData>[] = [
    {
      field: 'itemId',
      headerName: '상품코드',
      width: 127,
    },
    {
      field: 'itemName',
      headerName: '상품명',
      minWidth: 240,
      flex: 1,
    },
    {
      field: 'quantity',
      headerName: '구매수량',
      width: 79,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeOrderDetailOrderInfoData, TypeOrderDetailOrderInfoData['quantity']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'cancelQuantity',
      headerName: '취소수량',
      width: 99,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeOrderDetailOrderInfoData, TypeOrderDetailOrderInfoData['cancelQuantity']>) =>
        value ? formatNumber(value) : '-',
    },
  ];

  return { columnDefs };
};

export default getOrderDetailProductInfoColumnDefs;
